import {NgModule} from '@angular/core';
import {ConfigPage} from "./page/overview/config/config.page";
import {
    BmContractPaymentCalculatorComponent
} from "./component/protected-components/bm-contract-payment-calculator/bm-contract-payment-calculator.component";
import {
    BmContractPaymentCalculatorDataComponent
} from "./component/protected-components/bm-contract-payment-calculator-data/bm-contract-payment-calculator-data.component";
import {
    BmContractPaymentCalculatorSimulationComponent
} from "./component/protected-components/bm-contract-payment-calculator-simulation/bm-contract-payment-calculator-simulation.component";
import {
    BmContractPaymentCalculatorFullComponent
} from "./component/protected-components/bm-contract-payment-calculator/view/full/bm-contract-payment-calculator-full.component";
import {
    BmContractPaymentCalculatorSideComponent
} from "./component/protected-components/bm-contract-payment-calculator/view/side/bm-contract-payment-calculator-side.component";
import {
    BmContractPaymentCalculatorBase
} from "./component/protected-components/bm-contract-payment-calculator/view/bm-contract-payment-calculator.base";
import {
    BmPaymentAllocationDashboardPage
} from "./page/dashboards/bm-payment-allocation-dashboard/bm-payment-allocation-dashboard.page";
import {
    BmContractPlannedPaymentDashboardPage
} from "./page/dashboards/bm-contract-planned-payment-dashboard/bm-contract-planned-payment-dashboard.page";
import {
    BmCustomerBillingDashboardPage
} from "./page/dashboards/bm-customer-billing-dashboard/bm-customer-billing-dashboard.page";
import {
    BmBillingDashboardOverviewPage
} from "./page/bm-billing-dashboard-overview-page/bm-billing-dashboard-overview.page";
import {
    BmBillingRunsComponent
} from "./component/protected-components/bm-billing-runs-component/bm-billing-runs.component";
import {
    BmBillingRunDetailsComponent
} from "./component/protected-components/bm-billing-run-details-component/bm-billing-run-details.component";
import {
    BmContractPlannedAmountTraceComponent
} from "./component/protected-components/bm-contract-planned-amount-trace-component/bm-contract-planned-amount-trace.component";
import {
    BmCustomerCreditTraceComponent
} from "./component/protected-components/bm-customer-credit-trace-component/bm-customer-credit-trace.component";
import {
    BmPaymentReceivedTraceComponent
} from "./component/protected-components/bm-payment-received-trace-component/bm-payment-received-trace.component";
import {
    BmBillingRunDetailedReportComponent
} from "./component/protected-components/bm-billing-run-detailed-report-component/bm-billing-run-detailed-report.component";
import {
    BmContractPaymentCalculatorBillingRunComponent
} from "./component/protected-components/bm-contract-payment-calculator-billing-run/bm-contract-payment-calculator-billing-run.component";
import {
    BmCreditorObjectComponent
} from "./component/object-components/bm-creditor-object-component/bm-creditor-object.component";
import {
    BmCreditorObjectFullComponent
} from "./component/object-components/bm-creditor-object-component/view/bm-creditor-object-component-full/bm-creditor-object-full.component";
import {
    BmCreditorObjectBaseComponent
} from "./component/object-components/bm-creditor-object-component/view/bm-creditor-object-base.component";
import {
    BmCreditorObjectSideComponent
} from "./component/object-components/bm-creditor-object-component/view/bm-creditor-object-component-side/bm-creditor-object-side.component";
import {
    CreditorBankAccountDetailsComponent
} from "./component/object-components/bm-creditor-object-component/shared/components/creditor-bank-account-details-component/creditor-bank-account-details.component";
import {
    CreditorBasicDataComponent
} from "./component/object-components/bm-creditor-object-component/shared/components/creditor-basic-data-component/creditor-basic-data.component";
import {
    BmCreditorCamtImportConfigObjectComponent
} from "./component/object-components/bm-creditor-camt-import-config-object-component/bm-creditor-camt-import-config-object.component";
import {
    BmCreditorCamtImportConfigBaseComponent
} from "./component/object-components/bm-creditor-camt-import-config-object-component/view/bm-creditor-camt-import-config-base.component";
import {
    BmCreditorCamtImportConfigFullComponent
} from "./component/object-components/bm-creditor-camt-import-config-object-component/view/bm-creditor-camt-import-config-full/bm-creditor-camt-import-config-full.component";
import {
    BmCreditorCamtImportConfigSideComponent
} from "./component/object-components/bm-creditor-camt-import-config-object-component/view/bm-creditor-camt-import-config-side/bm-creditor-camt-import-config-side.component";
import {
    CamtImportConfigDocumentTypesComponent
} from "./component/object-components/bm-creditor-camt-import-config-object-component/shared/components/camt-import-config-document-types-component/camt-import-config-document-types.component";
import {
    BmBillingRunObjectComponent
} from "./component/protected-components/bm-billing-run-object-component/bm-billing-run-object.component";
import {
    BmAccountInfoComponent
} from "./component/protected-components/bm-account-info-component/bm-account-info.component";
import {
    BmCustomerAccountObjectComponent
} from "./component/object-components/bm-customer-account-object-component/bm-customer-account-object.component";
import {
    BmCustomerAccountObjectFullComponent
} from "./component/object-components/bm-customer-account-object-component/view/bm-customer-account-object-component-full/bm-customer-account-object-full.component";
import {
    BmCustomerAccountObjectSideComponent
} from "./component/object-components/bm-customer-account-object-component/view/bm-customer-account-object-component-side/bm-customer-account-object-side.component";
import {
    BmCustomerAccountObjectBaseComponent
} from "./component/object-components/bm-customer-account-object-component/view/bm-customer-account-object-base.component";
import {
    BmCustomerAccountTransactionComponent
} from "./component/object-components/bm-customer-account-object-component/shared/bm-customer-account-transaction-component/bm-customer-account-transaction.component";
import {
    BmCustomerAccountBasicDetailsComponent
} from "./component/object-components/bm-customer-account-object-component/shared/bm-customer-account-basic-details-component/bm-customer-account-basic-details.component";
import {
    BmCustomerBillingAccountTransactionObjectBaseComponent
} from "./component/object-components/bm-customer-billing-account-transaction-object-component/view/bm-customer-billing-account-transaction-object-base.component";
import {
    BmCustomerBillingAccountTransactionObjectComponent
} from "./component/object-components/bm-customer-billing-account-transaction-object-component/bm-customer-billing-account-transaction-object.component";
import {
    BmCustomerBillingAccountTransactionObjectSideComponent
} from "./component/object-components/bm-customer-billing-account-transaction-object-component/view/bm-customer-billing-account-transaction-object-component-side/bm-customer-billing-account-transaction-object-side.component";
import {
    BmCustomerBillingAccountTransactionObjectFullComponent
} from "./component/object-components/bm-customer-billing-account-transaction-object-component/view/bm-customer-billing-account-transaction-object-component-full/bm-customer-billing-account-transaction-object-full.component";
import {
    BmContractPaymentComponent
} from "./component/object-components/bm-customer-billing-account-transaction-object-component/shared/components/bm-contract-payment/bm-contract-payment.component";
import {
    BmCustomerBillingAccountComponent
} from "./component/object-components/bm-customer-billing-account-transaction-object-component/shared/components/bm-customer-billing-account/bm-customer-billing-account.component";
import {
    BmCustomerBillingAccountTransactionComponent
} from "./component/object-components/bm-customer-billing-account-transaction-object-component/shared/components/bm-customer-billing-account-transaction/bm-customer-billing-account-transaction.component";
import {
    BmBankInfoCardComponent
} from "./component/protected-components/bm-bank-info-card-component/bm-bank-info-card.component";
import {
    BmBankBadgeComponent
} from "./component/shared/bm-bank-badge-component/bm-bank-badge.component";
import {
    BmCustomerAccountTransactionItemComponent
} from "./component/object-components/bm-customer-account-object-component/shared/bm-customer-account-transaction-item/bm-customer-account-transaction-item.component";
import {
    BmCustomerAccountTransactionContentComponent
} from "./component/object-components/bm-customer-account-object-component/shared/bm-customer-account-transaction-content/bm-customer-account-transaction-content.component";
import {
    BmBillingRunStatusFlowComponent
} from "./component/protected-components/bm-billing-run-status-flow-component/bm-billing-run-status-flow.component";
import {
    BmCustomerBillingAccountTransactionSepaObjectComponent
} from "./component/object-components/bm-customer-billing-account-transaction-sepa-object-component/bm-customer-billing-account-transaction-sepa-object.component";
import {
    BmCustomerBillingAccountTransactionSepaObjectComponentBase
} from "./component/object-components/bm-customer-billing-account-transaction-sepa-object-component/view/bm-customer-billing-account-transaction-sepa-object.component-base";
import {
    BmCustomerBillingAccountTransactionSepaObjectComponentSide
} from "./component/object-components/bm-customer-billing-account-transaction-sepa-object-component/view/bm-customer-billing-account-transaction-sepa-object-component-side/bm-customer-billing-account-transaction-sepa-object.component-side";
import {
    BmCustomerBillingAccountTransactionSepaObjectComponentFull
} from "./component/object-components/bm-customer-billing-account-transaction-sepa-object-component/view/bm-customer-billing-account-transaction-sepa-object-component-full/bm-customer-billing-account-transaction-sepa-object.component-full";
import {
    SepaBasicDetailsComponent
} from "./component/object-components/bm-customer-billing-account-transaction-sepa-object-component/shared/sepa-basic-details-component/sepa-basic-details.component";
import {
    BmCustomerAccountTransactionForSepaComponent
} from "./component/object-components/bm-customer-billing-account-transaction-sepa-object-component/shared/bm-customer-account-transaction-for-sepa-component/bm-customer-account-transaction-for-sepa.component";
import {
    BmCreditorBankAccountObjectComponent
} from "./component/object-components/bm-creditor-bank-account-object-component/bm-creditor-bank-account-object.component";
import {
    BmCreditorBankAccountBaseComponentBase
} from "./component/object-components/bm-creditor-bank-account-object-component/view/bm-creditor-bank-account-base.component-base";
import {
    BmCreditorBankAccountSideComponent
} from "./component/object-components/bm-creditor-bank-account-object-component/view/bm-creditor-bank-account-side/bm-creditor-bank-account-side.component";
import {
    BmCreditorBankAccountFullComponent
} from "./component/object-components/bm-creditor-bank-account-object-component/view/bm-creditor-bank-account-full/bm-creditor-bank-account-full.component";
import {
    BmCreditorBankAccountImportObjectComponent
} from "./component/object-components/bm-creditor-bank-account-import-object-component/bm-creditor-bank-account-import-object.component";
import {
    BmCreditorBankAccountImportBaseComponentBase
} from "./component/object-components/bm-creditor-bank-account-import-object-component/view/bm-creditor-bank-account-import-base.component-base";
import {
    BmCreditorBankAccountImportSideComponent
} from "./component/object-components/bm-creditor-bank-account-import-object-component/view/bm-creditor-bank-account-import-side.component-side/bm-creditor-bank-account-import-side.component";
import {
    BmCreditorBankAccountImportFullComponent
} from "./component/object-components/bm-creditor-bank-account-import-object-component/view/bm-creditor-bank-account-import-side.component-full/bm-creditor-bank-account-import-full.component";
import {
    BmCreditorBankAccountImportFullComponentFull
} from "./component/object-components/bm-creditor-bank-account-import-object-component/view/bm-creditor-bank-account-import-side.component-full/bm-creditor-bank-account-import-full.component-full";
import {
    BmCreditorBankAccountImportSideComponentSide
} from "./component/object-components/bm-creditor-bank-account-import-object-component/view/bm-creditor-bank-account-import-side.component-side/bm-creditor-bank-account-import-side.component-side";
import {
    BmCreditorBankAccountBasicDetailsComponent
} from "./component/object-components/bm-creditor-bank-account-object-component/shared/bm-creditor-bank-account-basic-details-component/bm-creditor-bank-account-basic-details.component";
import {
    BmCreditorBankAccountImportComponent
} from "./component/object-components/bm-creditor-bank-account-object-component/shared/bm-creditor-bank-account-import-component/bm-creditor-bank-account-import.component";
import {
    BmCreditorTransactionHistoryChartComponent
} from "./component/shared/bm-creditor-transaction-history-chart-component/bm-creditor-transaction-history-chart.component";
import {
    BmCreditorCamtUploadComponent
} from "./component/object-components/bm-creditor-object-component/shared/components/creditor-camt-upload-component/bm-creditor-camt-upload.component";
import {
    BmCreditorTransactionAnalysisComponent
} from "./component/object-components/bm-creditor-object-component/shared/components/creditor-transaction-analysis-component/bm-creditor-transaction-analysis.component";
import {
    BmCreditorCamtImportsComponent
} from "./component/object-components/bm-creditor-object-component/shared/components/creditor-camt-imports-component/bm-creditor-camt-imports.component";
import {
    BmCreditorBankAccountDashboardComponent
} from "./component/object-components/bm-creditor-bank-account-object-component/shared/bm-creditor-bank-account-dashboard-component/bm-creditor-bank-account-dashboard.component";
import {DmModule} from "../../feature-core/dm/dm.module";
import {BdModule} from "../bd/bd.module";
import {
    BmCreditorBankAccountTransactionComponent
} from "./component/object-components/bm-creditor-bank-account-import-object-component/shared/bm-creditor-bank-account-transaction-component/bm-creditor-bank-account-transaction.component";
import {
    BmCreditorBankAccountImportBasicDetailsComponent
} from "./component/object-components/bm-creditor-bank-account-import-object-component/shared/bm-creditor-bank-account-import-basic-details-component/bm-creditor-bank-account-import-basic-details.component";
import {
    BmCreditorBankAccountTransactionCategoryComponent
} from "./component/object-components/bm-creditor-bank-account-import-object-component/shared/bm-creditor-bank-account-transaction-category-component/bm-creditor-bank-account-transaction-category.component";
import {
    BmCreditorBankAccountTransactionsComponent
} from "./component/object-components/bm-creditor-bank-account-object-component/shared/bm-creditor-bank-account-transactions-component/bm-creditor-bank-account-transactions.component";
import {
    BmCreditorBankAccountToolingAreaComponent
} from "./component/object-components/bm-creditor-bank-account-object-component/shared/bm-creditor-bank-account-tooling-area-component/bm-creditor-bank-account-tooling-area.component";
import {
    BmCreditorDetailsComponent
} from "./component/protected-components/bm-creditor-details-component/bm-creditor-details.component";

import {DunningConfigComponent} from "./page/overview/config/dunning-config/dunning-config.component";
import {
    BmCustomerBillingTransactionTypeBillingRunTypesComponent
} from "./component/object-components/bm-customer-billing-transaction-type-object-component/shared/bm-customer-billing-transaction-type-billing-run-types/bm-customer-billing-transaction-type-billing-run-types.component";
import {
    BmCustomerBillingTransactionTypeBillingRunTypeSepaChargesComponent
} from "./component/object-components/bm-customer-billing-transaction-type-object-component/shared/bm-customer-billing-transaction-type-billing-run-type-sepa-charges/bm-customer-billing-transaction-type-billing-run-type-sepa-charges.component";
import {
    BmDunningTypeLevelTriggerLogicFieldComponent
} from "./component/object-components/bm-dunning-type-trigger-object-component/shared/components/bm-dunning-type-level-trigger-logic-field/bm-dunning-type-level-trigger-logic-field.component";
import {
    BmDunningTypeTriggerLogicFieldComponent
} from "./component/object-components/bm-dunning-type-trigger-object-component/shared/components/bm-dunning-type-trigger-logic-field/bm-dunning-type-trigger-logic-field.component";
import {
    BmDunningTypeTriggerDataComponent
} from "./component/object-components/bm-dunning-type-trigger-object-component/shared/components/bm-dunning-type-trigger/bm-dunning-type-trigger-data.component";
import {
    BmDunningTypeTriggerObjectComponent
} from "./component/object-components/bm-dunning-type-trigger-object-component/bm-dunning-type-trigger-object.component";
import {
    BmDunningTypeTriggerBaseComponent
} from "./component/object-components/bm-dunning-type-trigger-object-component/view/bm-dunning-type-trigger-base.component";
import {
    BmDunningTypeTriggerSideComponent
} from "./component/object-components/bm-dunning-type-trigger-object-component/view/bm-dunning-type-trigger-side-component/bm-dunning-type-trigger-side.component";
import {
    BmDunningTypeTriggerFullComponent
} from "./component/object-components/bm-dunning-type-trigger-object-component/view/bm-dunning-type-trigger-full-component/bm-dunning-type-trigger-full.component";
import {BmLaunchpadPage} from "./launchpad/bm-launchpad.page";
import {BM_TEST_PROVIDERS} from "./test/bm-test-definition";
import {BM_ENTITY_PROVIDER} from "./bm.entity-provider";
import {CoreModule} from "../../core/core.module";
import {UiModule} from "../../core/ui/ui.module";
import {PeriodDurationPipe} from "../../core/shared/pipes/mvs-period-duration.pipe";
import {BmRatingActionHintPipe} from "./page/bm-payment-reconciliation-page/pipes/bm-rating-action-hint.pipe";
import {BmMatchReasonPartsPipe} from "./page/bm-payment-reconciliation-page/pipes/bm-match-reason-parts.pipe";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {FeatureBmRoutingModule} from "../feature-bm.routing.module";
import {
    BmBillingAreaObjectComponent
} from "./component/object-components/bm-billing-area-object-component/bm-billing-area-object.component";
import {
    BmBillingAreaFullComponent
} from "./component/object-components/bm-billing-area-object-component/view/bm-billing-area-full/bm-billing-area-full.component";
import {
    BmBillingAreaBaseComponent
} from "./component/object-components/bm-billing-area-object-component/view/bm-billing-area-base.component";
import {
    BmBillingAreaSideComponent
} from "./component/object-components/bm-billing-area-object-component/view/bm-billing-area-side/bm-billing-area-side.component";
import {
    BmCustomerBillingTransactionTypeObjectComponent
} from "./component/object-components/bm-customer-billing-transaction-type-object-component/bm-customer-billing-transaction-type-object.component";
import {
    BmCustomerBillingTransactionTypeFullComponent
} from "./component/object-components/bm-customer-billing-transaction-type-object-component/view/bm-customer-billing-transaction-type-full/bm-customer-billing-transaction-type-full.component";
import {
    BmCustomerBillingTransactionTypeBaseComponent
} from "./component/object-components/bm-customer-billing-transaction-type-object-component/view/bm-customer-billing-transaction-type-base.component";
import {
    BmCustomerBillingTransactionTypeSideComponent
} from "./component/object-components/bm-customer-billing-transaction-type-object-component/view/bm-customer-billing-transaction-type-side/bm-customer-billing-transaction-type-side.component";
import {
    BmBankTransactionDomainObjectComponent
} from "./component/object-components/bm-bank-transaction-domain-object-component/bm-bank-transaction-domain-object.component";
import {
    BmBankTransactionDomainFullComponent
} from "./component/object-components/bm-bank-transaction-domain-object-component/view/bm-bank-transaction-domain-full/bm-bank-transaction-domain-full.component";
import {
    BmBankTransactionDomainBaseComponent
} from "./component/object-components/bm-bank-transaction-domain-object-component/view/bm-bank-transaction-domain-base.component";
import {
    BmBankTransactionDomainSideComponent
} from "./component/object-components/bm-bank-transaction-domain-object-component/view/bm-bank-transaction-domain-side/bm-bank-transaction-domain-side.component";
import {
    BmBankTransactionFamilyObjectComponent
} from "./component/object-components/bm-bank-transaction-family-object-component/bm-bank-transaction-family-object.component";
import {
    BmBankTransactionFamilyFullComponent
} from "./component/object-components/bm-bank-transaction-family-object-component/view/bm-bank-transaction-family-full/bm-bank-transaction-family-full.component";
import {
    BmBankTransactionFamilyBaseComponent
} from "./component/object-components/bm-bank-transaction-family-object-component/view/bm-bank-transaction-family-base.component";
import {
    BmBankTransactionFamilySideComponent
} from "./component/object-components/bm-bank-transaction-family-object-component/view/bm-bank-transaction-family-side/bm-bank-transaction-family-side.component";
import {
    BmBillingAreaDetailsComponent
} from "./component/object-components/bm-billing-area-object-component/shared/bm-billing-area-details/bm-billing-area-details.component";
import {
    BmBillingAreaPartnersComponent
} from "./component/object-components/bm-billing-area-object-component/shared/bm-billing-area-partners/bm-billing-area-partners.component";
import {
    BmBillingAreaBillingRunTypesComponent
} from "./component/object-components/bm-billing-area-object-component/shared/bm-billing-area-billing-run-types/bm-billing-area-billing-run-types.component";
import {
    BmBillingAreaPaymentReminderTypesComponent
} from "./component/object-components/bm-billing-area-object-component/shared/bm-billing-area-payment-reminder-types/bm-billing-area-payment-reminder-types.component";
import {
    BmCustomerBillingTransactionTypeDetailsComponent
} from "./component/object-components/bm-customer-billing-transaction-type-object-component/shared/bm-customer-billing-transaction-type-details/bm-customer-billing-transaction-type-details.component";
import {
    BmBankTransactionDomainDetailsComponent
} from "./component/object-components/bm-bank-transaction-domain-object-component/shared/bm-bank-transaction-domain-details/bm-bank-transaction-domain-details.component";
import {
    BmBankTransactionFamilyDetailsComponent
} from "./component/object-components/bm-bank-transaction-family-object-component/shared/bm-bank-transaction-family-details/bm-bank-transaction-family-details.component";
import {LaunchpadModule} from "../../feature-launchpad/launchpad/launchpad.module";
import {LaunchpadRegistryService} from "../../feature-launchpad/launchpad/service/launchpad-registry.service";
import {BmLaunchpadProvider} from "./launchpad/bm-launchpad.provider";
import {
    BmCustomerBillingPaymentCalculatorComponent
} from "./component/protected-components/bm-customer-billing-payment-calculator/bm-customer-billing-payment-calculator.component";
import {
    BmFileComparisonOverviewComponent
} from "./page/overview/bm-file-comparison-overview-page/bm-file-comparison-overview.component";
import {
    BmPainViewComponent
} from "./page/overview/bm-file-comparison-overview-page/components/bm-pain-view/bm-pain-view.component";
import {
    BmCompareViewComponent
} from "./page/overview/bm-file-comparison-overview-page/components/bm-compare-view/bm-compare-view.component";
import {
    BmCamtViewComponent
} from "./page/overview/bm-file-comparison-overview-page/components/bm-camt-view/bm-camt-view.component";
import {
    CustomerBillingAccountDunningAssignPaymentsComponent
} from "./component/protected-components/customer-billing-account-dunning/customer-billing-account-dunning-assign-payments.component";

import {
    BmCustomerBillingAccountDunningPaymentPlanComponent
} from "./component/protected-components/bm-customer-billing-account-dunning-payment-plan-component/bm-customer-billing-account-dunning-payment-plan.component";
import {
    BmCustomerBillingAccountDunningPaymentPlanTestComponent
} from "./component/protected-components/bm-customer-billing-account-dunning-payment-plan-component/test/component/bm-customer-billing-account-dunning-payment-plan-test.component";
import {
    CustomerBillingAccountDunningAssignPaymentsTestComponent
} from "./component/protected-components/customer-billing-account-dunning/test/component/customer-billing-account-dunning-assign-payments-test.component";
import {
    BmPaymentPlanComponent
} from "./activity/payment-plan/component/bm-payment-plan-component/bm-payment-plan.component";
import {
    BmPaymentPlanBalanceComponent
} from "./activity/payment-plan/component/bm-payment-plan-balance-component/bm-payment-plan-balance.component";
import {
    BmPaymentPlanActivityComponent
} from "./activity/payment-plan/component/bm-payment-plan-activity-component/bm-payment-plan-activity.component";
import {
    BmPaymentPlanTestComponent
} from "./activity/payment-plan/component/bm-payment-plan-test-component/bm-payment-plan-test.component";
import {TabsModule} from "primeng/tabs";
import {CommonModule} from "@angular/common";
import {
    BmCustomerBillingDunningRemainder
} from "./component/protected-components/bm-customer-billing-dunning-remainder/bm-customer-billing-dunning-remainder";
import {
    BmCustomerBillingDunningRemainderTestComponent
} from "./component/protected-components/bm-customer-billing-dunning-remainder/test/component/bm-customer-billing-dunning-remainder-test.component";
import {
    BmContractPaymentPlannedComponent
} from "./component/protected-components/bm-contract-payment-planned/bm-contract-payment-planned.component";
import {
    BmContractPaymentPlannedTestComponent
} from "./component/protected-components/bm-contract-payment-planned/test/component/bm-contract-payment-planned-test.component";
import {AccordionModule} from "primeng/accordion";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {MessageModule} from "primeng/message";
import {
    BmDunningAssignPaymentsCalculationComponent
} from "./component/protected-components/customer-billing-account-dunning/components/bm-dunning-assign-payments-calculation/bm-dunning-assign-payments-calculation.component";
import {
    BmDunningAssignPaymentsComponent
} from "./component/protected-components/customer-billing-account-dunning/components/bm-dunning-assign-payments/bm-dunning-assign-payments.component";
import {
    OneTimePaymentDialogComponent
} from "./activity/payment-plan/component/shared-components/one-time-payment-dialog/one-time-payment-dialog.component";
import {
    BmContractToolbarComponent
} from "./activity/payment-plan/component/bm-contract-toolbar-component/bm-contract-toolbar.component";
import {
    ToolPanelComponent
} from "./component/protected-components/customer-billing-account-dunning/components/tool-panel/tool-panel.component";
import {
    AdjustPaymentsDialogComponent
} from "./component/protected-components/customer-billing-account-dunning/components/adjust-payments-dialog/adjust-payments-dialog.component";
import {
    BmDebtCollectionComponent
} from "./activity/debt-collection/component/bm-debt-collection-component/bm-debt-collection.component";
import {
    BmDebtCollectionBalanceComponent
} from "./activity/debt-collection/component/bm-debt-collection-balance-component/bm-debt-collection-balance.component";
import {
    BmDebtCollectionActivityComponent
} from "./activity/debt-collection/component/bm-debt-collection-activity-component/bm-debt-collection-activity.component";
import {
    BmManualPaymentDialogComponent
} from "./activity/debt-collection/component/shared/manual-payment-dialog/manual-payment-dialog.component";
import {
    BmBillingStartComponent
} from "./component/protected-components/bm-billing-start-component/bm-billing-start.component";
import {
    BmBillingHistoryComponent
} from "./component/protected-components/bm-billing-history-component/bm-billing-history.component";
import {
    BmBillingAnalyticsComponent
} from "./component/protected-components/bm-billing-analytics-component/bm-billing-analytics.component";
import {
    BmBillingCreditorComponent
} from "./component/protected-components/bm-billing-creditor-component/bm-billing-creditor.component";
import {
    BmBillingQualityChecksComponent
} from "./component/protected-components/bm-billing-quality-checks-component/bm-billing-quality-checks.component";
import {
    BmBillingFeeSettlementComponent
} from "./component/protected-components/bm-billing-fee-settlement-component/bm-billing-fee-settlement.component";
import {
    BmBillingBrowseComponent
} from "./component/protected-components/bm-billing-browse-component/bm-billing-browse.component";
import {
    BmCustomerBillingAccountsOverviewComponent
} from "./component/protected-components/bm-customer-billing-accounts-overview/bm-customer-billing-accounts-overview.component";
import {
    BmCustomerAccountBankConnectionsComponent
} from "./component/protected-components/bm-customer-account-bank-connections/bm-customer-account-bank-connections.component";
import {BmSepaFilesComponent} from "./component/protected-components/bm-sepa-files-component/bm-sepa-files.component";
import {BmPaymentReconciliationPage} from "./page/bm-payment-reconciliation-page/bm-payment-reconciliation.page";
import {
    BmPaymentReconciliationDashboardComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-dashboard/bm-payment-reconciliation-dashboard.component";
import {
    BmPaymentReconciliationAssignmentComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-assignment/bm-payment-reconciliation-assignment.component";
import {
    BmPaymentReconciliationConsistencyComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-consistency/bm-payment-reconciliation-consistency.component";
import {
    BmPaymentReconciliationImportsComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-imports/bm-payment-reconciliation-imports.component";
import {
    BmPaymentReconciliationUploadComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-upload/bm-payment-reconciliation-upload.component";
import {
    BmPaymentReconciliationRulesComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-rules/bm-payment-reconciliation-rules.component";
import {
    BmPaymentReconciliationAccountsComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-accounts/bm-payment-reconciliation-accounts.component";
import {
    BmPaymentReconciliationJobsComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-jobs/bm-payment-reconciliation-jobs.component";
import {
    BmPaymentReconciliationDunningComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-dunning/bm-payment-reconciliation-dunning.component";
import {
    BmBillingAccountSuggestionCardComponent
} from "./component/protected-components/bm-billing-account-suggestion-card/bm-billing-account-suggestion-card.component";
import {
    BmReconciliationSuggestionsTabComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-assignment/tabs/suggestions-tab/bm-reconciliation-suggestions-tab.component";
import {
    BmReconciliationSearchTabComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-assignment/tabs/search-tab/bm-reconciliation-search-tab.component";
import {
    BmReconciliationActionsTabComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-assignment/tabs/actions-tab/bm-reconciliation-actions-tab.component";
import {
    BmReconciliationCreateRuleTabComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-assignment/tabs/create-rule-tab/bm-reconciliation-create-rule-tab.component";
import {
    BmReconciliationDetailPanelComponent
} from "./page/bm-payment-reconciliation-page/components/bm-reconciliation-detail-panel/bm-reconciliation-detail-panel.component";
import {
    BmTransactionHistoryTableComponent
} from "./page/bm-payment-reconciliation-page/components/bm-payment-reconciliation-imports/bm-transaction-history-table/bm-transaction-history-table.component";

// Reusable frequency components (FD-17: ONE frequency UI) — embedded by the „Abrechnungskonto ändern“
// wizard below and by the cr merge wizard („Abrechnungskonten verschmelzen“).
import {
    BmFrequencyContractSelectionComponent
} from "./component/public-components/bm-frequency-contract-selection/bm-frequency-contract-selection.component";
import {BmFrequencyTargetComponent} from "./component/public-components/bm-frequency-target/bm-frequency-target.component";
import {
    BmFrequencyChangePreviewComponent
} from "./component/public-components/bm-frequency-change-preview/bm-frequency-change-preview.component";
import {
    BmContractFrequencyAlignmentComponent
} from "./component/public-components/bm-contract-frequency-alignment/bm-contract-frequency-alignment.component";

// „Abrechnungskonto ändern“ wizard (bm-customer-billing-account-change-wizard, design 02-wizard-design.md):
// host + nine steps on the core wizard building blocks. The step chain lives ONLY in
// BmCustomerBillingAccountChangeWizardStateService#getStepChain (provided by the host, WZ-009).
import {
    BmCustomerBillingAccountChangeWizardComponent
} from "./component/object-components/bm-customer-billing-account-change-wizard/bm-customer-billing-account-change-wizard.component";
import {
    BmCbacwStepAccountComponent
} from "./component/protected-components/bm-customer-billing-account-change-wizard/bm-cbacw-step-account/bm-cbacw-step-account.component";
import {
    BmCbacwStepTopicComponent
} from "./component/protected-components/bm-customer-billing-account-change-wizard/bm-cbacw-step-topic/bm-cbacw-step-topic.component";
import {
    BmCbacwStepPaymentMethodComponent
} from "./component/protected-components/bm-customer-billing-account-change-wizard/bm-cbacw-step-payment-method/bm-cbacw-step-payment-method.component";
import {
    BmCbacwStepMandateDocumentComponent
} from "./component/protected-components/bm-customer-billing-account-change-wizard/bm-cbacw-step-mandate-document/bm-cbacw-step-mandate-document.component";
import {
    BmCbacwStepDueDayComponent
} from "./component/protected-components/bm-customer-billing-account-change-wizard/bm-cbacw-step-due-day/bm-cbacw-step-due-day.component";
import {
    BmCbacwStepFrequencyContractsComponent
} from "./component/protected-components/bm-customer-billing-account-change-wizard/bm-cbacw-step-frequency-contracts/bm-cbacw-step-frequency-contracts.component";
import {
    BmCbacwStepFrequencyTargetComponent
} from "./component/protected-components/bm-customer-billing-account-change-wizard/bm-cbacw-step-frequency-target/bm-cbacw-step-frequency-target.component";
import {
    BmCbacwStepFrequencyConfirmComponent
} from "./component/protected-components/bm-customer-billing-account-change-wizard/bm-cbacw-step-frequency-confirm/bm-cbacw-step-frequency-confirm.component";
import {
    BmCbacwStepSummaryComponent
} from "./component/protected-components/bm-customer-billing-account-change-wizard/bm-cbacw-step-summary/bm-cbacw-step-summary.component";
import {
    BmCbacwStepIntentComponent
} from "./component/protected-components/bm-customer-billing-account-change-wizard/bm-cbacw-step-intent/bm-cbacw-step-intent.component";
import {
    BmCbacwStepCreateComponent
} from "./component/protected-components/bm-customer-billing-account-change-wizard/bm-cbacw-step-create/bm-cbacw-step-create.component";

// TM-1000002058: „Beitragsänderungs-Information“ - review workbench of tab 8 in the billing run (worklist, run
// toolbar, notice detail, bulk approval dialog of the toolbar) and the configuration section of the billing area.
import {
    BmPremiumChangeWorklistComponent
} from "./component/protected-components/premium-change/bm-premium-change-worklist/bm-premium-change-worklist.component";
import {
    BmPremiumChangeRunToolbarComponent
} from "./component/protected-components/premium-change/bm-premium-change-run-toolbar/bm-premium-change-run-toolbar.component";
import {
    BmPremiumChangeNoticeDetailComponent
} from "./component/protected-components/premium-change/bm-premium-change-notice-detail/bm-premium-change-notice-detail.component";
import {
    BmPremiumChangeBulkApproveDialogComponent
} from "./component/protected-components/premium-change/bm-premium-change-bulk-approve-dialog/bm-premium-change-bulk-approve-dialog.component";
import {
    BmBillingAreaPremiumChangeNoticeTypesComponent
} from "./component/object-components/bm-billing-area-object-component/shared/bm-billing-area-premium-change-notice-types/bm-billing-area-premium-change-notice-types.component";
import {NsModule} from "../../feature-core/ns/ns.module";

@NgModule({
    declarations: [
        ConfigPage,
        BmContractPaymentCalculatorComponent,
        BmContractPaymentCalculatorDataComponent,
        BmContractPaymentCalculatorSimulationComponent,
        BmContractPaymentCalculatorFullComponent,
        BmContractPaymentCalculatorSideComponent,
        BmContractPaymentCalculatorBase,
        BmPaymentAllocationDashboardPage,
        BmContractPlannedPaymentDashboardPage,
        BmCustomerBillingDashboardPage,
        BmBillingDashboardOverviewPage,
        BmBillingRunsComponent,
        BmBillingRunDetailsComponent,
        BmContractPlannedAmountTraceComponent,
        BmCustomerCreditTraceComponent,
        BmPaymentReceivedTraceComponent,
        BmBillingRunDetailedReportComponent,
        BmContractPaymentCalculatorBillingRunComponent,
        BmCreditorObjectComponent,
        BmCreditorObjectFullComponent,
        BmCreditorObjectSideComponent,
        BmCreditorObjectBaseComponent,
        CreditorBankAccountDetailsComponent,
        CreditorBasicDataComponent,
        BmCreditorCamtImportConfigObjectComponent,
        BmCreditorCamtImportConfigBaseComponent,
        BmCreditorCamtImportConfigFullComponent,
        BmCreditorCamtImportConfigSideComponent,
        CamtImportConfigDocumentTypesComponent,
        BmBillingRunObjectComponent,
        BmAccountInfoComponent,
        BmCustomerAccountObjectComponent,
        BmCustomerAccountObjectFullComponent,
        BmCustomerAccountObjectSideComponent,
        BmCustomerAccountObjectBaseComponent,
        BmCustomerAccountBasicDetailsComponent,
        BmCustomerBillingAccountTransactionObjectComponent,
        BmCustomerBillingAccountTransactionObjectBaseComponent,
        BmCustomerBillingAccountTransactionObjectSideComponent,
        BmCustomerBillingAccountTransactionObjectFullComponent,
        BmContractPaymentComponent,
        BmCustomerBillingAccountComponent,
        BmCustomerBillingAccountTransactionComponent,
        BmBankInfoCardComponent,
        BmBankBadgeComponent,
        BmBillingAccountSuggestionCardComponent,
        BmBillingRunStatusFlowComponent,
        BmBankInfoCardComponent,
        BmBankBadgeComponent,
        BmCustomerAccountTransactionItemComponent,
        BmCustomerAccountTransactionContentComponent,
        BmCustomerBillingAccountTransactionSepaObjectComponent,
        BmCustomerBillingAccountTransactionSepaObjectComponentBase,
        BmCustomerBillingAccountTransactionSepaObjectComponentSide,
        BmCustomerBillingAccountTransactionSepaObjectComponentFull,
        SepaBasicDetailsComponent,
        BmCustomerAccountTransactionForSepaComponent,
        BmCreditorBankAccountObjectComponent,
        BmCreditorBankAccountBaseComponentBase,
        BmCreditorBankAccountSideComponent,
        BmCreditorBankAccountFullComponent,
        BmCreditorBankAccountImportObjectComponent,
        BmCreditorBankAccountImportBaseComponentBase,
        BmCreditorBankAccountImportSideComponent,
        BmCreditorBankAccountImportFullComponent,
        BmCreditorBankAccountImportFullComponentFull,
        BmCreditorBankAccountImportSideComponentSide,
        BmCreditorBankAccountBasicDetailsComponent,
        BmCreditorBankAccountImportComponent,
        BmCreditorTransactionHistoryChartComponent,
        BmCreditorCamtUploadComponent,
        BmCreditorTransactionAnalysisComponent,
        BmCreditorCamtImportsComponent,
        BmCreditorBankAccountDashboardComponent,
        BmCreditorBankAccountTransactionComponent,
        BmCreditorBankAccountImportBasicDetailsComponent,
        BmCreditorBankAccountTransactionCategoryComponent,
        BmCreditorBankAccountTransactionsComponent,
        BmCreditorBankAccountToolingAreaComponent,
        BmCreditorDetailsComponent,
        BmCreditorBankAccountToolingAreaComponent,
        DunningConfigComponent,
        BmDunningTypeLevelTriggerLogicFieldComponent,
        BmDunningTypeTriggerLogicFieldComponent,
        BmDunningTypeTriggerDataComponent,
        BmDunningTypeTriggerObjectComponent,
        BmDunningTypeTriggerObjectComponent,
        BmDunningTypeTriggerBaseComponent,
        BmDunningTypeTriggerSideComponent,
        BmDunningTypeTriggerFullComponent,
        BmCustomerBillingPaymentCalculatorComponent,
        BmFileComparisonOverviewComponent,
        BmPainViewComponent,
        BmCompareViewComponent,
        BmCamtViewComponent,
        BmCustomerBillingAccountDunningPaymentPlanComponent,
        BmCustomerBillingAccountDunningPaymentPlanTestComponent,
        CustomerBillingAccountDunningAssignPaymentsComponent,
        CustomerBillingAccountDunningAssignPaymentsTestComponent,
        CustomerBillingAccountDunningAssignPaymentsComponent,
        BmPaymentPlanComponent,
        BmPaymentPlanBalanceComponent,
        BmPaymentPlanActivityComponent,
        BmPaymentPlanTestComponent,
        CustomerBillingAccountDunningAssignPaymentsComponent,
        BmCustomerBillingDunningRemainder,
        BmCustomerBillingDunningRemainderTestComponent,
        BmContractPaymentPlannedComponent,
        BmContractPaymentPlannedTestComponent,
        BmContractPaymentPlannedComponent,
        BmDunningAssignPaymentsCalculationComponent,
        BmDunningAssignPaymentsComponent,
        OneTimePaymentDialogComponent,
        BmContractToolbarComponent,
        BmDunningAssignPaymentsComponent,
        ToolPanelComponent,
        AdjustPaymentsDialogComponent,
        BmDunningAssignPaymentsComponent,
        BmDebtCollectionComponent,
        BmDebtCollectionBalanceComponent,
        BmDebtCollectionActivityComponent,
        BmManualPaymentDialogComponent,
        BmBillingStartComponent,
        BmBillingHistoryComponent,
        BmBillingAnalyticsComponent,
        BmBillingCreditorComponent,
        BmBillingQualityChecksComponent,
        BmBillingFeeSettlementComponent,
        BmBillingBrowseComponent,
        BmCustomerBillingAccountsOverviewComponent,
        BmSepaFilesComponent,
        BmPaymentReconciliationPage,
        BmPaymentReconciliationDashboardComponent,
        BmPaymentReconciliationAssignmentComponent,
        BmReconciliationSuggestionsTabComponent,
        BmReconciliationSearchTabComponent,
        BmReconciliationActionsTabComponent,
        BmReconciliationCreateRuleTabComponent,
        BmReconciliationDetailPanelComponent,
        BmPaymentReconciliationConsistencyComponent,
        BmPaymentReconciliationDunningComponent,
        BmPaymentReconciliationImportsComponent,
        BmTransactionHistoryTableComponent,
        BmPaymentReconciliationUploadComponent,
        BmPaymentReconciliationRulesComponent,
        BmPaymentReconciliationAccountsComponent,
        BmPaymentReconciliationJobsComponent,
        BmBillingAreaObjectComponent,
        BmBillingAreaFullComponent,
        BmBillingAreaBaseComponent,
        BmBillingAreaSideComponent,
        BmCustomerBillingTransactionTypeObjectComponent,
        BmCustomerBillingTransactionTypeFullComponent,
        BmCustomerBillingTransactionTypeBaseComponent,
        BmCustomerBillingTransactionTypeSideComponent,
        BmBankTransactionDomainObjectComponent,
        BmBankTransactionDomainFullComponent,
        BmBankTransactionDomainBaseComponent,
        BmBankTransactionDomainSideComponent,
        BmBankTransactionFamilyObjectComponent,
        BmBankTransactionFamilyFullComponent,
        BmBankTransactionFamilyBaseComponent,
        BmBankTransactionFamilySideComponent,
        BmBillingAreaDetailsComponent,
        BmBillingAreaPartnersComponent,
        BmBillingAreaBillingRunTypesComponent,
        BmBillingAreaPaymentReminderTypesComponent,
        BmCustomerBillingTransactionTypeDetailsComponent,
        BmCustomerBillingTransactionTypeBillingRunTypesComponent,
        BmCustomerBillingTransactionTypeBillingRunTypeSepaChargesComponent,
        BmBankTransactionDomainDetailsComponent,
        BmBankTransactionFamilyDetailsComponent,
        BmLaunchpadPage,

        // Bank connections tab of the account object page ("Bankverbindungen": time-sliced bank
        // slices, SEPA pre-check, run messages). Rendered only by the bm account full view.
        BmCustomerAccountBankConnectionsComponent,

        // The reusable frequency components (FD-17: ONE frequency UI), embedded by the
        // „Abrechnungskonto ändern“ wizard's frequency steps and by the merge wizard in cr
        BmFrequencyContractSelectionComponent,
        BmFrequencyTargetComponent,
        BmFrequencyChangePreviewComponent,
        BmContractFrequencyAlignmentComponent,

        // „Abrechnungskonto ändern“ wizard — host + nine steps
        BmCustomerBillingAccountChangeWizardComponent,
        BmCbacwStepAccountComponent,
        BmCbacwStepTopicComponent,
        BmCbacwStepPaymentMethodComponent,
        BmCbacwStepMandateDocumentComponent,
        BmCbacwStepDueDayComponent,
        BmCbacwStepFrequencyContractsComponent,
        BmCbacwStepFrequencyTargetComponent,
        BmCbacwStepFrequencyConfirmComponent,
        BmCbacwStepSummaryComponent,
        BmCbacwStepIntentComponent,
        BmCbacwStepCreateComponent,

        // TM-1000002058: premium change review workbench (tab 8 of bm-billing-run-details) + area configuration
        BmPremiumChangeWorklistComponent,
        BmPremiumChangeRunToolbarComponent,
        BmPremiumChangeNoticeDetailComponent,
        BmPremiumChangeBulkApproveDialogComponent,
        BmBillingAreaPremiumChangeNoticeTypesComponent
    ],
    exports: [
        ConfigPage,
        BmContractPaymentCalculatorComponent,
        BmContractPaymentCalculatorDataComponent,
        BmContractPaymentCalculatorSimulationComponent,
        BmContractPaymentCalculatorFullComponent,
        BmContractPaymentCalculatorSideComponent,
        BmContractPaymentCalculatorBase,
        BmPaymentAllocationDashboardPage,
        BmContractPlannedPaymentDashboardPage,
        BmCustomerBillingDashboardPage,
        BmBillingDashboardOverviewPage,
        BmBillingRunsComponent,
        BmBillingRunDetailsComponent,
        BmContractPlannedAmountTraceComponent,
        BmCustomerCreditTraceComponent,
        BmPaymentReceivedTraceComponent,
        BmBillingRunDetailedReportComponent,
        BmContractPaymentCalculatorBillingRunComponent,
        BmCreditorObjectComponent,
        BmCreditorObjectFullComponent,
        BmCreditorObjectSideComponent,
        BmCreditorObjectBaseComponent,
        CreditorBankAccountDetailsComponent,
        CreditorBasicDataComponent,
        BmCreditorCamtImportConfigObjectComponent,
        BmCreditorCamtImportConfigBaseComponent,
        BmCreditorCamtImportConfigFullComponent,
        BmCreditorCamtImportConfigSideComponent,
        CamtImportConfigDocumentTypesComponent,
        BmBillingRunObjectComponent,
        BmAccountInfoComponent,
        BmCustomerAccountObjectComponent,
        BmCustomerAccountObjectFullComponent,
        BmCustomerAccountObjectSideComponent,
        BmCustomerAccountObjectBaseComponent,
        BmCustomerAccountTransactionComponent,
        BmCustomerAccountBasicDetailsComponent,
        BmCustomerBillingAccountTransactionObjectComponent,
        BmCustomerBillingAccountTransactionObjectBaseComponent,
        BmCustomerBillingAccountTransactionObjectSideComponent,
        BmCustomerBillingAccountTransactionObjectFullComponent,
        BmBillingRunStatusFlowComponent,
        BmBillingAccountSuggestionCardComponent,
        // EXPORTED so modules that import BmModule can render a bank the way bm renders it.
        // It was declared but not exported, which made it bm-internal by accident rather than by
        // decision: the component is a pure display of ONE bank (avatar from the `imageOrIcon`
        // token, name, initials fallback) and owns that rendering rule for the whole house. The
        // first outside caller is cr-object-billing-accounts, whose panel cards show the bank of a
        // billing account. cr -> bm is an established edge (CrModule already imports BmModule);
        // the forbidden direction is bm -> cr, and exporting changes nothing about that.
        BmBankBadgeComponent,
        BmCustomerBillingAccountTransactionSepaObjectComponent,
        BmCustomerBillingAccountTransactionSepaObjectComponentBase,
        BmCustomerBillingAccountTransactionSepaObjectComponentSide,
        BmCustomerBillingAccountTransactionSepaObjectComponentFull,
        SepaBasicDetailsComponent,
        BmCustomerAccountTransactionForSepaComponent,
        BmCreditorBankAccountObjectComponent,
        BmCreditorBankAccountBaseComponentBase,
        BmCreditorBankAccountSideComponent,
        BmCreditorBankAccountFullComponent,
        BmCreditorBankAccountImportObjectComponent,
        BmCreditorBankAccountImportBaseComponentBase,
        BmCreditorBankAccountImportSideComponent,
        BmCreditorBankAccountImportFullComponent,
        BmCreditorBankAccountImportFullComponentFull,
        BmCreditorBankAccountImportSideComponentSide,
        BmCreditorBankAccountBasicDetailsComponent,
        BmCreditorBankAccountImportComponent,
        BmCreditorTransactionHistoryChartComponent,
        BmCreditorCamtUploadComponent,
        BmCreditorTransactionAnalysisComponent,
        BmCreditorCamtImportsComponent,
        BmCreditorBankAccountDashboardComponent,
        BmCreditorBankAccountTransactionComponent,
        BmCreditorBankAccountImportBasicDetailsComponent,
        BmCreditorBankAccountTransactionCategoryComponent,
        BmCreditorBankAccountTransactionsComponent,
        BmCreditorBankAccountToolingAreaComponent,
        BmDunningTypeTriggerDataComponent,
        BmDunningTypeTriggerObjectComponent,
        BmDunningTypeTriggerBaseComponent,
        BmDunningTypeTriggerSideComponent,
        BmDunningTypeTriggerFullComponent,
        BmCustomerBillingPaymentCalculatorComponent,
        BmCustomerBillingAccountDunningPaymentPlanComponent,
        BmCustomerBillingAccountDunningPaymentPlanTestComponent,
        CustomerBillingAccountDunningAssignPaymentsTestComponent,
        BmPaymentPlanComponent,
        BmPaymentPlanBalanceComponent,
        BmPaymentPlanActivityComponent,
        BmPaymentPlanTestComponent,
        // CustomerBillingAccountDunningAssignPaymentsTestComponent
        BmCustomerBillingDunningRemainder,
        BmCustomerBillingDunningRemainderTestComponent,
        BmContractPaymentPlannedComponent,
        BmContractPaymentPlannedTestComponent,
        BmContractPaymentPlannedTestComponent,
        BmDebtCollectionComponent,
        BmCustomerBillingAccountsOverviewComponent,
        BmSepaFilesComponent,
        BmPaymentReconciliationPage,
        BmPaymentReconciliationDashboardComponent,
        BmPaymentReconciliationAssignmentComponent,
        BmReconciliationSuggestionsTabComponent,
        BmReconciliationSearchTabComponent,
        BmReconciliationActionsTabComponent,
        BmReconciliationCreateRuleTabComponent,
        BmReconciliationDetailPanelComponent,
        BmPaymentReconciliationConsistencyComponent,
        BmPaymentReconciliationDunningComponent,
        BmPaymentReconciliationImportsComponent,
        BmPaymentReconciliationUploadComponent,
        BmPaymentReconciliationRulesComponent,
        BmPaymentReconciliationAccountsComponent,
        BmPaymentReconciliationJobsComponent,
        BmBillingBrowseComponent,
        BmBillingAreaObjectComponent,
        BmBillingAreaFullComponent,
        BmBillingAreaBaseComponent,
        BmBillingAreaSideComponent,
        BmCustomerBillingTransactionTypeObjectComponent,
        BmCustomerBillingTransactionTypeFullComponent,
        BmCustomerBillingTransactionTypeBaseComponent,
        BmCustomerBillingTransactionTypeSideComponent,
        BmBankTransactionDomainObjectComponent,
        BmBankTransactionDomainFullComponent,
        BmBankTransactionDomainBaseComponent,
        BmBankTransactionDomainSideComponent,
        BmBankTransactionFamilyObjectComponent,
        BmBankTransactionFamilyFullComponent,
        BmBankTransactionFamilyBaseComponent,
        BmBankTransactionFamilySideComponent,
        BmLaunchpadPage,

        // The reusable frequency components; exported because the cr merge wizard
        // („Abrechnungskonten verschmelzen“) embeds the alignment and the preview (cr -> bm is the
        // established edge)
        BmFrequencyContractSelectionComponent,
        BmFrequencyTargetComponent,
        BmFrequencyChangePreviewComponent,
        BmContractFrequencyAlignmentComponent,

        // „Abrechnungskonto ändern“ wizard — exported for the cr quick actions (cr -> bm is the established edge)
        BmCustomerBillingAccountChangeWizardComponent
    ],
    imports: [
        CommonModule,
        CoreModule,
        UiModule,
        PeriodDurationPipe,
        BmRatingActionHintPipe,
        BmMatchReasonPartsPipe,
        DmModule,
        // TM-1000002058: bm-premium-change-notice-detail renders mvs-ns-notification-send (letter preview) and
        // mvs-ns-object-sent-notifications (Sendungsakte), both exported by NsModule. NsModule imports only
        // CoreModule + DmModule (+ PrimeNG) and nothing of feature-bm - no cycle; BdModule below already
        // imports it, so it is no new edge in the graph. (mvs-widget + its custom-field directive: SharedModule
        // via CoreModule.)
        NsModule,
        BdModule,
        FeatureBmRoutingModule,
        AccordionModule,
        TabsModule,
        ConfirmDialogModule,
        MessageModule,
        LaunchpadModule,
        // Now standalone — imported so its template usages inside BmModule
        // (e.g. bm-customer-account-object-full) keep resolving.
        BmCustomerAccountTransactionComponent,
        // cm-wizard-message-area and mvs-wizard-step-card, rendered by the steps of the
        // „Abrechnungskonto ändern“ wizard, are declared and exported by SharedModule, which
        // CoreModule above re-exports — nothing to import here.
    ],
    providers: [
        BM_TEST_PROVIDERS,
        BM_ENTITY_PROVIDER,
    ]
})
export class BmModule implements DynamicModule {

    alias = 'bm';

    constructor(
        private moduleRegistry: ModuleRegistryService,
        private launchpadRegistry: LaunchpadRegistryService
    ) {
        this.moduleRegistry.registerModule(this);
        this.launchpadRegistry.register(new BmLaunchpadProvider());
    }

    getKpiComponent() {
        return null;
    }

    getStatisticsComponent() {
        return null;
    }
}
